/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required, @atlaskit/volt-strict-mode/no-re-exports, @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated re-export shims. */
/**
 * @deprecated Use `import Avatar from '@atlaskit/avatar/Avatar'` instead.
 */
export { default } from './avatar';
/**
 * @deprecated Use `import type { AvatarPropTypes } from '@atlaskit/avatar/Avatar'` instead.
 */
export type { AvatarPropTypes } from './avatar';
/**
 * @deprecated Use `import { AvatarContent } from '@atlaskit/avatar/avatar-content'` instead.
 */
export { AvatarContent } from './avatar-content';
/**
 * @deprecated Use `import AvatarItem from '@atlaskit/avatar/AvatarItem'` instead.
 */
export { default as AvatarItem } from './avatar-item';
/**
 * @deprecated Use `import type { AvatarItemProps } from '@atlaskit/avatar/AvatarItem'` instead.
 */
export type { AvatarItemProps } from './avatar-item';
/**
 * @deprecated Use `import Presence from '@atlaskit/avatar/presence'` instead.
 */
export { default as Presence } from './presence';
/**
 * @deprecated Use `import type { PresenceProps } from '@atlaskit/avatar/presence'` instead.
 */
export type { PresenceProps } from './presence';
/**
 * @deprecated Use `import Status from '@atlaskit/avatar/status'` instead.
 */
export { default as Status } from './status';
/**
 * @deprecated Use `import type { StatusProps } from '@atlaskit/avatar/status'` instead.
 */
export type { StatusProps } from './status';
/**
 * @deprecated Use `import Skeleton from '@atlaskit/avatar/Skeleton'` instead.
 */
export { default as Skeleton } from './skeleton';
/**
 * @deprecated Use `import type { SkeletonProps } from '@atlaskit/avatar/Skeleton'` instead.
 */
export type { SkeletonProps } from './skeleton';
/**
 * @deprecated Use `import getAppearanceForAppType from '@atlaskit/avatar/get-appearance'` instead.
 */
export { default as getAppearanceForAppType } from './get-appearance';

/**
 * @deprecated Use `import { AvatarContext } from '@atlaskit/avatar/avatar-context'` instead.
 */
export { AvatarContext } from './avatar-context';
/**
 * @deprecated Use `import type { AvatarContextProps } from '@atlaskit/avatar/avatar-context'` instead.
 */
export type { AvatarContextProps } from './avatar-context';
/**
 * @deprecated Use `import { useAvatarContext } from '@atlaskit/avatar/use-avatar-context'` instead.
 */
export { useAvatarContext } from './use-avatar-context';

/**
 * @deprecated Use `import { BORDER_WIDTH, ACTIVE_SCALE_FACTOR } from '@atlaskit/avatar/constants/default'` instead.
 */
export { BORDER_WIDTH, ACTIVE_SCALE_FACTOR } from './constants';
/**
 * @deprecated Use `import { AVATAR_SIZES } from '@atlaskit/avatar/avatar-sizes'` instead.
 */
export { AVATAR_SIZES } from './avatar-sizes';
/**
 * @deprecated Use `import { AVATAR_RADIUS } from '@atlaskit/avatar/avatar-radius'` instead.
 */
export { AVATAR_RADIUS } from './avatar-radius';

/**
 * @deprecated Use `import type { AvatarClickEventHandler, AppearanceType, SizeType, PresenceType, StatusType, IndicatorSizeType } from '@atlaskit/avatar/types'` instead.
 */
export type {
	AvatarClickEventHandler,
	AppearanceType,
	SizeType,
	Presence as PresenceType,
	Status as StatusType,
	IndicatorSizeType,
} from './types';
